import {
  CoordinateOrder,
  DisplayMode,
  SlopeAngleFormat,
  SlopeDisplayMode,
  SlopeMeasurementSettings,
} from '@trimble/types';
import { UnitSettings } from './unit-settings.types';

export const DEFAULT_UNIT_SETTINGS: UnitSettings = {
  unitSystem: 'metric',
  lengthUnit: 'm',
  lengthUnitFormat: '0.001',
  lengthMeasurementUnit: 'm',
  lengthMeasurementUnitFormat: '0.001',
  areaUnit: 'm2',
  areaUnitFormat: '0.001',
  volumeUnit: 'm3',
  volumeUnitFormat: '0.001',
  weightUnit: 'kg',
  weightUnitFormat: '0.01',
  angularUnit: 'deg',
  angularUnitFormat: '0.01',
  slopeUnit: 'percentage' as SlopeAngleFormat,
  slopeDisplayMode: 0 as SlopeDisplayMode,
  coordinateOrder: 'NEZ' as CoordinateOrder,
};

export const DEFAULT_SLOPE_MEASUREMENT_SETTINGS: SlopeMeasurementSettings = {
  displayMode: DisplayMode.Slope,
  format: 'percentage',
};
